import { IconChevronRight } from 'central-icons/IconChevronRight';

import type { ImpersonationPreset } from '@revelio/auth';
import { Button, Radio, RadioGroup } from '@revelio/ui';

import styles from './impersonationCards.module.css';

/** Mirrors the testid derivation the e2e suite relies on (preset-cst-trial, …). */
const toTestId = (name: string) =>
  `preset-${name.toLowerCase().replace(/\s+/g, '-')}`;

interface ImpersonationPresetCardsProps {
  presets: ImpersonationPreset[];
  selectedPresetName: string | null;
  onSelectPreset: (preset: ImpersonationPreset) => void;
  onEditOverrides: () => void;
}

export function ImpersonationPresetCards({
  presets,
  selectedPresetName,
  onSelectPreset,
  onEditOverrides,
}: ImpersonationPresetCardsProps) {
  return (
    <div>
      <RadioGroup
        name="impersonation-preset"
        aria-label="Impersonation preset"
        value={selectedPresetName ?? ''}
        onChange={(value) => {
          const preset = presets.find((candidate) => candidate.name === value);

          if (preset) {
            onSelectPreset(preset);
          }
        }}
        className={styles.presetList}
      >
        {presets.map((preset) => (
          <Radio
            key={preset.name}
            value={preset.name}
            className={styles.presetCard}
            data-testid={toTestId(preset.name)}
          >
            <span className={styles.cardTitle}>{preset.name}</span>
            <span className={styles.cardDescription}>{preset.description}</span>
          </Radio>
        ))}
      </RadioGroup>

      {selectedPresetName && (
        <div className={styles.presetActions}>
          <Button
            variant="ghost"
            size="sm"
            rightIcon={<IconChevronRight size={14} ariaHidden={true} />}
            onClick={onEditOverrides}
            data-testid="edit-preset-overrides-button"
          >
            Edit overrides
          </Button>
        </div>
      )}
    </div>
  );
}
